module.exports = __webpack_public_path__ + "img/tfp_condensed_logo.9123dac0.png";